module.exports = __webpack_public_path__ + "static/img/OOSH_025.ed2cbea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_025.jpg
// module id = dXjU
// module chunks = 170